import { ReactElement, ReactNode } from 'react'
import { Download } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab'
import {
  Checkbox,
  ListItem,
  ListItemText,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material'
import { Stack } from '@mui/system'

interface Props {
  title: string
  isLoading: boolean

  options: { label: string; value: string }[]
  selectedOptions: Array<string>
  handleChange: (event: SelectChangeEvent<string[]>) => void
  onClick: () => void
  icon?: ReactNode
  buttonSize?: 'small' | 'medium' | 'large'
  'data-cy'?: string
}

const ExportMultiSelectItem = ({
  title,
  isLoading,
  options,
  selectedOptions,
  handleChange,
  onClick,
  icon,
  buttonSize = 'large',
  'data-cy': dataCy,
}: Props): ReactElement => {
  return (
    <ListItem>
      <ListItemText primary={title} />

      <Stack direction="row" spacing={1.5} ml={2}>
        <Select
          value={selectedOptions}
          multiple
          onChange={handleChange}
          size="small"
          sx={{ height: 34.57 }}
          renderValue={selected => {
            const selectedOptionsLabelValue = options.filter(({ value }) =>
              selected.includes(value),
            )
            const selectedLabels = selectedOptionsLabelValue.map(({ label }) => label)
            return selectedLabels.sort().join(', ')
          }}
        >
          {options.map(({ value, label }) => (
            <MenuItem key={value} value={value}>
              <Checkbox checked={selectedOptions.indexOf(value) > -1} />
              <ListItemText primary={label} />
            </MenuItem>
          ))}
        </Select>

        <LoadingButton
          variant="outlined"
          loading={isLoading}
          onClick={onClick}
          size={buttonSize}
          data-cy={dataCy}
        >
          {icon ?? <Download fontSize="small" />}
        </LoadingButton>
      </Stack>
    </ListItem>
  )
}

export default ExportMultiSelectItem
